// extracted by mini-css-extract-plugin
export default {"header":"MetropoleOnlyHeader_header__hV31Y","logo":"MetropoleOnlyHeader_logo__dGvGz"};